import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "commission-page"
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_vm.loading ? _c('div', {
    staticClass: "card-body text-center py-15"
  }, [_c('span', {
    staticClass: "spinner spinner-primary spinner-lg"
  }), _c('div', {
    staticClass: "text-muted mt-5"
  }, [_vm._v("Carregando regras de comissão...")])]) : [_c('div', {
    staticClass: "card-body pt-5"
  }, [_c('div', {
    staticClass: "plan-navigation"
  }, [_c('router-link', {
    staticClass: "btn btn-sm btn-light-primary font-weight-bold",
    attrs: {
      "to": {
        name: 'vendedorLista'
      }
    }
  }, [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "arrow-left"
    }
  }), _vm._v(" Vendedores ")], 1), _c('div', {
    staticClass: "plan-navigation-summary"
  }, [_c('div', {
    staticClass: "configuration-icon"
  }, [_c('b-icon', {
    attrs: {
      "icon": "sliders"
    }
  })], 1), _c('div', [_c('strong', {
    staticClass: "d-block text-dark"
  }, [_vm._v("Configuração de comissões")]), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" Regras únicas da empresa · " + _vm._s(_vm.eventoCompetenciaLabel) + " ")])])])], 1), _c('b-tabs', {
    staticClass: "commission-tabs",
    attrs: {
      "pills": ""
    },
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Visão geral"
    }
  }, [_c('div', {
    staticClass: "analysis-filter mb-5"
  }, [_c('b-row', {
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "3",
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Data inicial"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.periodo.data_inicial,
      callback: function callback($$v) {
        _vm.$set(_vm.periodo, "data_inicial", $$v);
      },
      expression: "periodo.data_inicial"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-3 mt-md-0",
    attrs: {
      "lg": "3",
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Data final"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.periodo.data_final,
      callback: function callback($$v) {
        _vm.$set(_vm.periodo, "data_final", $$v);
      },
      expression: "periodo.data_final"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-3 mt-lg-0",
    attrs: {
      "lg": "3",
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Vendedor"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.sellerOptions
    },
    model: {
      value: _vm.periodo.id_vendedor,
      callback: function callback($$v) {
        _vm.$set(_vm.periodo, "id_vendedor", $$v);
      },
      expression: "periodo.id_vendedor"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-3 mt-lg-0",
    attrs: {
      "lg": "3",
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.simular
    }
  }, [_vm.processing ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Atualizar análise ")], 1)])], 1), _c('div', {
    staticClass: "quick-periods"
  }, [_c('span', [_vm._v("Período rápido:")]), _vm._l(_vm.periodShortcuts, function (atalho) {
    return _c('button', {
      key: atalho.value,
      staticClass: "btn btn-xs",
      class: _vm.periodoRapidoAtivo === atalho.value ? 'btn-light-primary' : 'btn-light',
      attrs: {
        "type": "button",
        "disabled": _vm.processing
      },
      on: {
        "click": function click($event) {
          return _vm.aplicarPeriodoRapido(atalho.value);
        }
      }
    }, [_vm._v(" " + _vm._s(atalho.text) + " ")]);
  })], 2)], 1), _vm.resultado ? _c('div', {
    staticClass: "commission-overview"
  }, [_c('div', {
    staticClass: "row overview-kpis"
  }, _vm._l(_vm.overviewCards, function (card) {
    return _c('b-col', {
      key: card.titulo,
      staticClass: "mb-5",
      attrs: {
        "xl": "3",
        "md": "6"
      }
    }, [_c('div', {
      staticClass: "overview-kpi h-100"
    }, [_c('div', {
      staticClass: "overview-kpi-icon",
      class: card.classe
    }, [_c('b-icon', {
      attrs: {
        "icon": card.icone
      }
    })], 1), _c('div', [_c('span', [_vm._v(_vm._s(card.titulo))]), _c('strong', [_vm._v(_vm._s(card.valor))]), _c('small', [_vm._v(_vm._s(card.legenda))])])])]);
  }), 1), _c('div', {
    staticClass: "row"
  }, [_c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "xl": "8"
    }
  }, [_c('div', {
    staticClass: "dashboard-card h-100"
  }, [_c('div', {
    staticClass: "dashboard-card-header"
  }, [_c('div', [_c('h3', [_vm._v("Evolução das comissões")]), _c('p', [_vm._v(" Base comissionável e valor previsto ao longo do período. ")])]), _c('div', {
    staticClass: "history-grouping"
  }, _vm._l(_vm.historyGroupingOptions, function (opcao) {
    return _c('button', {
      key: opcao.value,
      staticClass: "btn btn-xs",
      class: _vm.agrupamentoHistorico === opcao.value ? 'btn-primary' : 'btn-light',
      attrs: {
        "type": "button",
        "disabled": _vm.processing
      },
      on: {
        "click": function click($event) {
          return _vm.alterarAgrupamentoHistorico(opcao.value);
        }
      }
    }, [_vm._v(" " + _vm._s(opcao.text) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "dashboard-card-body history-chart"
  }, [_c('apexchart', {
    attrs: {
      "height": "330",
      "options": _vm.opcoesGraficoEvolucao,
      "series": _vm.seriesGraficoEvolucao
    }
  }), !_vm.temHistorico ? _c('div', {
    staticClass: "chart-empty"
  }, [_vm._v(" Nenhum movimento de comissão encontrado neste período. ")]) : _vm._e()], 1)])]), _c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "xl": "4"
    }
  }, [_c('div', {
    staticClass: "dashboard-card h-100"
  }, [_c('div', {
    staticClass: "dashboard-card-header"
  }, [_c('div', [_c('h3', [_vm._v("À vista x a prazo")]), _c('p', [_vm._v("Composição da base em cada semana ou mês.")])])]), _c('div', {
    staticClass: "dashboard-card-body history-chart"
  }, [_c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "330",
      "options": _vm.opcoesGraficoModalidades,
      "series": _vm.seriesGraficoModalidades
    }
  }), !_vm.temHistorico ? _c('div', {
    staticClass: "chart-empty"
  }, [_vm._v(" Sem valores para comparar. ")]) : _vm._e()], 1)])])], 1), _c('div', {
    staticClass: "row"
  }, [_c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "xl": "8"
    }
  }, [_c('div', {
    staticClass: "dashboard-card h-100"
  }, [_c('div', {
    staticClass: "dashboard-card-header"
  }, [_c('div', [_c('h3', [_vm._v("Desempenho da equipe")]), _c('p', [_vm._v(" Realizado no período comparado à meta individual. ")])]), _c('span', {
    staticClass: "dashboard-chip"
  }, [_vm._v(" " + _vm._s(_vm.eventoCompetenciaLabel) + " ")])]), _c('div', {
    staticClass: "dashboard-card-body"
  }, [_c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "300",
      "options": _vm.opcoesGraficoDesempenho,
      "series": _vm.seriesGraficoDesempenho
    }
  })], 1)])]), _c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "xl": "4"
    }
  }, [_c('div', {
    staticClass: "dashboard-card h-100"
  }, [_c('div', {
    staticClass: "dashboard-card-header"
  }, [_c('div', [_c('h3', [_vm._v("Composição a pagar")]), _c('p', [_vm._v("Comissão base e bônus da competência.")])])]), _c('div', {
    staticClass: "dashboard-card-body"
  }, [_c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "295",
      "options": _vm.opcoesGraficoComposicao,
      "series": _vm.seriesGraficoComposicao
    }
  }), !_vm.temComissaoComposicao ? _c('div', {
    staticClass: "chart-empty"
  }, [_vm._v(" Nenhuma comissão calculada no período. ")]) : _vm._e()], 1)])])], 1), _c('div', {
    staticClass: "dashboard-card"
  }, [_c('div', {
    staticClass: "dashboard-card-header"
  }, [_c('div', [_c('h3', [_vm._v("Ranking e desempenho individual")]), _c('p', [_vm._v(" Acompanhe participação, atingimento e valor previsto por vendedor. ")])]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.tabIndex = 5;
      }
    }
  }, [_vm._v(" Ir para apuração ")])]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-vertical-center mb-0 ranking-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _c('th', [_vm._v("Vendedor")]), _c('th', [_vm._v("Progresso da meta")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Realizado")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Participação")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(" " + _vm._s(_vm.resultadoPorRecebimento ? "Comissão disponível" : "Comissão prevista") + " ")])])]), _c('tbody', [_vm._l(_vm.rankingVendedores, function (vendedor, index) {
    return _c('tr', {
      key: vendedor.id_vendedor
    }, [_c('td', [_c('span', {
      staticClass: "ranking-position"
    }, [_vm._v(_vm._s(index + 1))])]), _c('td', [_c('strong', [_vm._v(_vm._s(vendedor.nome))]), _c('small', {
      staticClass: "d-block text-muted"
    }, [_vm._v(" " + _vm._s(vendedor.meta_individual ? "Meta " + _vm.money(vendedor.meta_individual) : "Sem meta individual") + " ")])]), _c('td', {
      staticClass: "progress-column"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between font-size-sm mb-1"
    }, [_c('span', [_vm._v(_vm._s(_vm.percent(vendedor.atingimento_individual)))]), _c('span', {
      class: vendedor.atingimento_individual >= 100 ? 'text-success' : 'text-muted'
    }, [_vm._v(" " + _vm._s(vendedor.atingimento_individual >= 100 ? "Meta atingida" : "Em andamento") + " ")])]), _c('div', {
      staticClass: "progress progress-xs"
    }, [_c('div', {
      staticClass: "progress-bar",
      class: vendedor.atingimento_individual >= 100 ? 'bg-success' : 'bg-primary',
      style: {
        width: Math.min(Number(vendedor.atingimento_individual || 0), 100) + '%'
      }
    })])]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.money(vendedor.realizado_individual)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.percent(vendedor.participacao_equipe)) + " ")]), _c('td', {
      staticClass: "text-right font-weight-bolder text-primary"
    }, [_vm._v(" " + _vm._s(_vm.money(_vm.resultadoPorRecebimento ? _vm.vendedorFinance(vendedor).valor_disponivel : vendedor.total_pagar)) + " ")])]);
  }), !_vm.rankingVendedores.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-8",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(" Nenhum desempenho encontrado neste período. ")])]) : _vm._e()], 2)])])])]) : _c('div', {
    staticClass: "empty-overview"
  }, [_c('b-icon', {
    attrs: {
      "icon": "bar-chart-line",
      "font-scale": "3"
    }
  }), _c('h4', [_vm._v("Pronto para analisar a equipe")]), _c('p', [_vm._v("Selecione o período e atualize a visão geral.")])], 1)]), _c('b-tab', {
    attrs: {
      "title": "Regras globais"
    }
  }, [_c('div', {
    staticClass: "section-heading tab-intro"
  }, [_c('div', [_c('span', {
    staticClass: "section-eyebrow"
  }, [_vm._v("Configuração padrão")]), _c('h5', [_vm._v("Regras globais da empresa")]), _c('p', [_vm._v(" Estas regras são herdadas por todos, exceto quando houver uma configuração individual. ")])])]), _c('div', {
    staticClass: "monthly-policy-note"
  }, [_c('b-icon', {
    attrs: {
      "icon": "calendar3"
    }
  }), _c('div', [_c('strong', [_vm._v("Competência mensal fixa")]), _c('span', [_vm._v(" Metas e faixas sempre consideram as vendas do dia 1 ao último dia de cada mês. ")])])], 1), _c('div', {
    staticClass: "config-panel"
  }, [_c('div', {
    staticClass: "config-panel-heading"
  }, [_c('div', {
    staticClass: "config-panel-icon is-coral"
  }, [_c('b-icon', {
    attrs: {
      "icon": "percent"
    }
  })], 1), _c('div', [_c('h6', [_vm._v("Comissão padrão")]), _c('p', [_vm._v("Percentuais e operações herdados por toda a equipe.")])])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Venda à vista"
    }
  }, [_c('b-input-group', {
    attrs: {
      "append": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "step": "0.01",
      "disabled": !_vm.isEditable
    },
    model: {
      value: _vm.plano.comissao_vista,
      callback: function callback($$v) {
        _vm.$set(_vm.plano, "comissao_vista", _vm._n($$v));
      },
      expression: "plano.comissao_vista"
    }
  })], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Venda a prazo"
    }
  }, [_c('b-input-group', {
    attrs: {
      "append": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "step": "0.01",
      "disabled": !_vm.isEditable
    },
    model: {
      value: _vm.plano.comissao_prazo,
      callback: function callback($$v) {
        _vm.$set(_vm.plano, "comissao_prazo", _vm._n($$v));
      },
      expression: "plano.comissao_prazo"
    }
  })], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "d-block"
  }, [_vm._v("Operações incluídas")]), _c('div', {
    staticClass: "source-options"
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "switch": ""
    },
    model: {
      value: _vm.plano.incluir_nfe,
      callback: function callback($$v) {
        _vm.$set(_vm.plano, "incluir_nfe", $$v);
      },
      expression: "plano.incluir_nfe"
    }
  }, [_vm._v(" NF-e ")]), _c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "switch": ""
    },
    model: {
      value: _vm.plano.incluir_nfce,
      callback: function callback($$v) {
        _vm.$set(_vm.plano, "incluir_nfce", $$v);
      },
      expression: "plano.incluir_nfce"
    }
  }, [_vm._v(" NFC-e ")]), _c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "switch": ""
    },
    model: {
      value: _vm.plano.incluir_pedidos,
      callback: function callback($$v) {
        _vm.$set(_vm.plano, "incluir_pedidos", $$v);
      },
      expression: "plano.incluir_pedidos"
    }
  }, [_vm._v(" Pedidos faturados ")]), _vm.hasModuloServicos ? _c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "switch": ""
    },
    model: {
      value: _vm.plano.incluir_os,
      callback: function callback($$v) {
        _vm.$set(_vm.plano, "incluir_os", $$v);
      },
      expression: "plano.incluir_os"
    }
  }, [_vm._v(" OS faturadas ")]) : _vm._e(), _c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "switch": ""
    },
    model: {
      value: _vm.plano.incluir_contratos,
      callback: function callback($$v) {
        _vm.$set(_vm.plano, "incluir_contratos", $$v);
      },
      expression: "plano.incluir_contratos"
    }
  }, [_vm._v(" Contratos ")])], 1)])], 1), _c('div', {
    staticClass: "timing-setting"
  }, [_c('div', {
    staticClass: "timing-setting-copy"
  }, [_c('span', [_vm._v("Liberação no financeiro")]), _c('p', [_vm._v(" A meta sempre usa as vendas do mês. Esta opção define apenas quando a conta a pagar pode ser gerada. ")])]), _c('div', {
    staticClass: "timing-options"
  }, [_c('button', {
    staticClass: "timing-option",
    class: {
      'is-selected': _vm.plano.evento_competencia === 'faturamento'
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.isEditable
    },
    on: {
      "click": function click($event) {
        _vm.plano.evento_competencia = 'faturamento';
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "receipt"
    }
  }), _c('span', [_c('strong', [_vm._v("No fechamento")]), _c('small', [_vm._v("Libera toda a comissão do mês")])])], 1), _c('button', {
    staticClass: "timing-option",
    class: {
      'is-selected': _vm.plano.evento_competencia === 'recebimento'
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.isEditable
    },
    on: {
      "click": function click($event) {
        _vm.plano.evento_competencia = 'recebimento';
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "cash-stack"
    }
  }), _c('span', [_c('strong', [_vm._v("Após o recebimento")]), _c('small', [_vm._v("Libera conforme o Contas a Receber")])])], 1)])])], 1), _c('div', {
    staticClass: "config-panel"
  }, [_c('div', {
    staticClass: "config-panel-heading"
  }, [_c('div', {
    staticClass: "config-panel-icon is-green"
  }, [_c('b-icon', {
    attrs: {
      "icon": "bullseye"
    }
  })], 1), _c('div', [_c('h6', [_vm._v("Meta da equipe")]), _c('p', [_vm._v(" Aplicada somente a vendedores sem uma meta individual. ")])])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Meta da equipe"
    }
  }, [_c('b-input-group', {
    attrs: {
      "prepend": "R$"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.isEditable
    },
    model: {
      value: _vm.plano.meta_equipe,
      callback: function callback($$v) {
        _vm.$set(_vm.plano, "meta_equipe", $$v);
      },
      expression: "plano.meta_equipe"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo do bônus"
    }
  }, [_c('b-form-select', {
    attrs: {
      "disabled": !_vm.isEditable,
      "options": _vm.bonusTypeOptions
    },
    model: {
      value: _vm.plano.bonus_equipe_tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.plano, "bonus_equipe_tipo", $$v);
      },
      expression: "plano.bonus_equipe_tipo"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.bonusValueLabel(_vm.plano.bonus_equipe_tipo)
    }
  }, [_vm.isMoneyBonusType(_vm.plano.bonus_equipe_tipo) ? _c('b-input-group', {
    attrs: {
      "prepend": "R$"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.isEditable
    },
    model: {
      value: _vm.plano.bonus_equipe_valor,
      callback: function callback($$v) {
        _vm.$set(_vm.plano, "bonus_equipe_valor", $$v);
      },
      expression: "plano.bonus_equipe_valor"
    }
  }, 'money', _vm.configMoney, false))], 1) : !_vm.plano.bonus_equipe_tipo ? _c('b-form-input', {
    attrs: {
      "disabled": "",
      "placeholder": "Selecione o tipo"
    }
  }) : _c('b-input-group', {
    attrs: {
      "append": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01",
      "disabled": !_vm.isEditable || !_vm.plano.bonus_equipe_tipo
    },
    model: {
      value: _vm.plano.bonus_equipe_valor,
      callback: function callback($$v) {
        _vm.$set(_vm.plano, "bonus_equipe_valor", _vm._n($$v));
      },
      expression: "plano.bonus_equipe_valor"
    }
  })], 1)], 1)], 1)], 1)], 1)]), _c('b-tab', {
    attrs: {
      "title": "Metas individuais"
    }
  }, [_c('div', {
    staticClass: "section-heading"
  }, [_c('div', [_c('h5', [_vm._v("Meta e comissão por vendedor")]), _c('p', [_vm._v(" Defina a meta e escolha uma tabela progressiva quando o percentual de comissão depender do atingimento. ")])])]), _c('div', {
    staticClass: "inheritance-note"
  }, [_c('b-icon', {
    attrs: {
      "icon": "layers"
    }
  }), _c('span', [_c('strong', [_vm._v("Regra simples:")]), _vm._v(" com uma tabela selecionada, ela substitui as comissões à vista e a prazo. Sem tabela, permanecem os percentuais individuais ou globais atuais. ")])], 1), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-head-custom table-vertical-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Vendedor")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Comissionar")]), _c('th', [_vm._v("Meta individual")]), _c('th', [_vm._v("Tabela de comissão")]), _c('th', [_vm._v("À vista")]), _c('th', [_vm._v("A prazo")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Meta equipe")])])]), _c('tbody', _vm._l(_vm.plano.vendedores, function (item) {
    return _c('tr', {
      key: item.id_vendedor
    }, [_c('td', {
      staticClass: "font-weight-bolder"
    }, [_vm._v(" " + _vm._s(_vm.vendedorNome(item.id_vendedor)) + " ")]), _c('td', {
      staticClass: "text-center"
    }, [_c('b-form-checkbox', {
      attrs: {
        "disabled": !_vm.isEditable,
        "switch": ""
      },
      model: {
        value: item.ativo,
        callback: function callback($$v) {
          _vm.$set(item, "ativo", $$v);
        },
        expression: "item.ativo"
      }
    })], 1), _c('td', {
      staticClass: "money-column"
    }, [_c('b-input-group', {
      attrs: {
        "prepend": "R$"
      }
    }, [_c('money', _vm._b({
      staticClass: "form-control",
      attrs: {
        "disabled": !_vm.isEditable || !item.ativo
      },
      model: {
        value: item.meta_individual,
        callback: function callback($$v) {
          _vm.$set(item, "meta_individual", $$v);
        },
        expression: "item.meta_individual"
      }
    }, 'money', _vm.configMoney, false))], 1), item.tabela_comissao_chave && Number(item.meta_individual || 0) <= 0 ? _c('small', {
      staticClass: "range-helper text-danger"
    }, [_vm._v(" Informe a meta para calcular as faixas ")]) : _vm._e()], 1), _c('td', {
      staticClass: "commission-table-column"
    }, [_c('b-form-select', {
      attrs: {
        "disabled": !_vm.isEditable || !item.ativo,
        "options": _vm.tabelaComissaoOptions
      },
      model: {
        value: item.tabela_comissao_chave,
        callback: function callback($$v) {
          _vm.$set(item, "tabela_comissao_chave", $$v);
        },
        expression: "item.tabela_comissao_chave"
      }
    }), item.tabela_comissao_chave ? _c('small', {
      staticClass: "range-helper range-helper-success"
    }, [_vm._v(" Comissão conforme o atingimento da meta ")]) : _vm._e()], 1), _c('td', {
      class: {
        'commission-inherited': Boolean(item.tabela_comissao_chave)
      }
    }, [_c('b-input-group', {
      attrs: {
        "append": "%"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "min": "0",
        "max": "100",
        "step": "0.01",
        "disabled": !_vm.isEditable || !item.ativo || Boolean(item.tabela_comissao_chave),
        "placeholder": item.tabela_comissao_chave ? 'Pela tabela' : 'Global'
      },
      model: {
        value: item.comissao_vista,
        callback: function callback($$v) {
          _vm.$set(item, "comissao_vista", $$v);
        },
        expression: "item.comissao_vista"
      }
    })], 1)], 1), _c('td', {
      class: {
        'commission-inherited': Boolean(item.tabela_comissao_chave)
      }
    }, [_c('b-input-group', {
      attrs: {
        "append": "%"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "min": "0",
        "max": "100",
        "step": "0.01",
        "disabled": !_vm.isEditable || !item.ativo || Boolean(item.tabela_comissao_chave),
        "placeholder": item.tabela_comissao_chave ? 'Pela tabela' : 'Global'
      },
      model: {
        value: item.comissao_prazo,
        callback: function callback($$v) {
          _vm.$set(item, "comissao_prazo", $$v);
        },
        expression: "item.comissao_prazo"
      }
    })], 1)], 1), _c('td', {
      staticClass: "text-center"
    }, [!_vm.temMetaIndividual(item) ? _c('b-form-checkbox', {
      attrs: {
        "disabled": !_vm.isEditable || !item.ativo,
        "switch": ""
      },
      model: {
        value: item.participa_meta_equipe,
        callback: function callback($$v) {
          _vm.$set(item, "participa_meta_equipe", $$v);
        },
        expression: "item.participa_meta_equipe"
      }
    }) : _c('span', {
      staticClass: "label label-inline label-light-primary"
    }, [_vm._v(" Substituída ")])], 1)]);
  }), 0)])])]), _c('b-tab', {
    attrs: {
      "title": "Faixas progressivas"
    }
  }, [_c('div', {
    staticClass: "section-heading"
  }, [_c('div', [_c('h5', [_vm._v("Tabelas progressivas de comissão")]), _c('p', [_vm._v(" Crie os modelos White Label, Cliente Final ou outros. O vínculo com cada vendedor é feito somente em Metas individuais. ")])]), _vm.isEditable ? _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.adicionarTabelaComissao
    }
  }, [_vm._v(" Nova tabela ")]) : _vm._e()]), !_vm.plano.tabelas_comissao.length ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._v(" Nenhuma tabela progressiva cadastrada. Os vendedores continuam usando as comissões à vista e a prazo. ")]) : _vm._e(), _vm._l(_vm.plano.tabelas_comissao, function (tabela, tabelaIndex) {
    return _c('div', {
      key: tabela._key,
      staticClass: "commission-table-card"
    }, [_c('div', {
      staticClass: "commission-table-header"
    }, [_c('div', {
      staticClass: "range-number"
    }, [_vm._v(_vm._s(tabelaIndex + 1))]), _c('div', {
      staticClass: "commission-table-identity"
    }, [_c('b-form-input', {
      attrs: {
        "disabled": !_vm.isEditable,
        "placeholder": "Nome da tabela, ex.: White Label — Experiência"
      },
      model: {
        value: tabela.nome,
        callback: function callback($$v) {
          _vm.$set(tabela, "nome", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "tabela.nome"
      }
    }), _c('b-form-input', {
      attrs: {
        "disabled": !_vm.isEditable,
        "placeholder": "Descrição opcional"
      },
      model: {
        value: tabela.descricao,
        callback: function callback($$v) {
          _vm.$set(tabela, "descricao", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "tabela.descricao"
      }
    })], 1), _c('div', {
      staticClass: "commission-table-usage"
    }, [_c('span', {
      staticClass: "label label-inline label-light-primary"
    }, [_vm._v(" " + _vm._s(_vm.quantidadeVendedoresTabela(tabela._key)) + " vendedor(es) ")]), _vm.isEditable ? _c('button', {
      staticClass: "btn btn-sm btn-icon btn-light-danger",
      attrs: {
        "type": "button",
        "title": "Remover tabela"
      },
      on: {
        "click": function click($event) {
          return _vm.removerTabelaComissao(tabelaIndex);
        }
      }
    }, [_c('b-icon', {
      attrs: {
        "icon": "trash"
      }
    })], 1) : _vm._e()])]), _c('div', {
      staticClass: "commission-tier-heading"
    }, [_c('div', [_c('strong', [_vm._v("Faixas de atingimento")]), _c('small', [_vm._v(" Defina quanto cada modalidade paga em cada faixa. ")])]), _c('div', {
      staticClass: "commission-tier-actions"
    }, [_c('button', {
      staticClass: "btn btn-sm font-weight-bold commission-link-button",
      class: tabela.vincular_percentuais ? 'btn-light-primary' : 'btn-light',
      attrs: {
        "type": "button",
        "disabled": !_vm.isEditable,
        "title": tabela.vincular_percentuais ? 'Desvincular os percentuais à vista e a prazo' : 'Usar no prazo os mesmos percentuais à vista'
      },
      on: {
        "click": function click($event) {
          return _vm.alternarVinculoPercentuais(tabela);
        }
      }
    }, [_c('b-icon', {
      staticClass: "mr-1",
      attrs: {
        "icon": "link"
      }
    }), _vm._v(" " + _vm._s(tabela.vincular_percentuais ? "Vista e prazo vinculados" : "Vista e prazo independentes") + " ")], 1), _vm.isEditable ? _c('button', {
      staticClass: "btn btn-sm btn-light-primary font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.adicionarFaixaTabela(tabela);
        }
      }
    }, [_vm._v(" Adicionar faixa ")]) : _vm._e()])]), !tabela.faixas.length ? _c('div', {
      staticClass: "tier-empty"
    }, [_vm._v(" Adicione a primeira faixa desta tabela. ")]) : _vm._e(), _vm._l(tabela.faixas, function (faixa, faixaIndex) {
      return _c('div', {
        key: faixa._key,
        staticClass: "commission-tier-row"
      }, [_c('div', {
        staticClass: "tier-sequence"
      }, [_vm._v(_vm._s(faixaIndex + 1))]), _c('b-form-group', {
        attrs: {
          "label": "De"
        }
      }, [_c('b-input-group', {
        attrs: {
          "append": "%"
        }
      }, [_c('b-form-input', {
        attrs: {
          "type": "number",
          "min": "0",
          "step": "1",
          "disabled": !_vm.isEditable || faixaIndex > 0
        },
        on: {
          "change": function change($event) {
            return _vm.onFaixaTabelaInicioAlterado(tabela, faixa, faixaIndex);
          },
          "wheel": _vm.desfocarCampoNumerico
        },
        model: {
          value: faixa.percentual_inicial,
          callback: function callback($$v) {
            _vm.$set(faixa, "percentual_inicial", _vm._n($$v));
          },
          expression: "faixa.percentual_inicial"
        }
      })], 1), faixaIndex > 0 ? _c('small', {
        staticClass: "range-helper"
      }, [_vm._v(" Até anterior + 1 ")]) : _vm._e()], 1), _c('b-form-group', {
        attrs: {
          "label": "Até"
        }
      }, [_c('b-input-group', {
        attrs: {
          "append": "%"
        }
      }, [_c('b-form-input', {
        attrs: {
          "type": "number",
          "min": Number(faixa.percentual_inicial || 0) + 1,
          "step": "1",
          "placeholder": "Sem limite",
          "disabled": !_vm.isEditable
        },
        on: {
          "change": function change($event) {
            return _vm.onFaixaTabelaLimiteAlterado(tabela, faixa, faixaIndex);
          },
          "wheel": _vm.desfocarCampoNumerico
        },
        model: {
          value: faixa.percentual_final,
          callback: function callback($$v) {
            _vm.$set(faixa, "percentual_final", _vm._n($$v));
          },
          expression: "faixa.percentual_final"
        }
      })], 1), faixa.percentual_final !== null && faixa.percentual_final !== '' ? _c('small', {
        staticClass: "range-helper range-helper-success"
      }, [_vm._v(" Próxima em " + _vm._s(_vm.percent(Number(faixa.percentual_final) + 1)) + " ")]) : _vm._e()], 1), _c('b-form-group', {
        attrs: {
          "label": "Comissão à vista"
        }
      }, [_c('b-input-group', {
        attrs: {
          "append": "%"
        }
      }, [_c('b-form-input', {
        attrs: {
          "type": "number",
          "min": "0",
          "max": "100",
          "step": "0.01",
          "disabled": !_vm.isEditable
        },
        on: {
          "input": function input($event) {
            return _vm.sincronizarPercentualPrazo(tabela, faixa);
          },
          "wheel": _vm.desfocarCampoNumerico
        },
        model: {
          value: faixa.comissao_percentual,
          callback: function callback($$v) {
            _vm.$set(faixa, "comissao_percentual", _vm._n($$v));
          },
          expression: "faixa.comissao_percentual"
        }
      })], 1)], 1), _c('b-form-group', {
        attrs: {
          "label": "Comissão a prazo"
        }
      }, [_c('b-input-group', {
        attrs: {
          "append": "%"
        }
      }, [_c('b-form-input', {
        attrs: {
          "type": "number",
          "min": "0",
          "max": "100",
          "step": "0.01",
          "disabled": !_vm.isEditable || tabela.vincular_percentuais
        },
        on: {
          "wheel": _vm.desfocarCampoNumerico
        },
        model: {
          value: faixa.comissao_percentual_prazo,
          callback: function callback($$v) {
            _vm.$set(faixa, "comissao_percentual_prazo", _vm._n($$v));
          },
          expression: "faixa.comissao_percentual_prazo"
        }
      })], 1), tabela.vincular_percentuais ? _c('small', {
        staticClass: "range-helper"
      }, [_vm._v(" Mesmo percentual à vista ")]) : _vm._e()], 1), _c('div', {
        staticClass: "tier-result"
      }, [_c('span', [_vm._v("Ao atingir esta faixa")]), _c('strong', [_vm._v(" " + _vm._s(_vm.percentualFaixaLabel(faixa, tabela.vincular_percentuais)) + " ")])]), _vm.isEditable ? _c('button', {
        staticClass: "btn btn-sm btn-icon btn-light-danger",
        attrs: {
          "type": "button",
          "title": "Remover faixa"
        },
        on: {
          "click": function click($event) {
            return _vm.removerFaixaTabela(tabela, faixaIndex);
          }
        }
      }, [_c('b-icon', {
        attrs: {
          "icon": "trash"
        }
      })], 1) : _vm._e()], 1);
    })], 2);
  })], 2), _c('b-tab', {
    attrs: {
      "title": "Formas de pagamento"
    }
  }, [_c('div', {
    staticClass: "section-heading"
  }, [_c('div', [_c('h5', [_vm._v("Classificação à vista ou a prazo")]), _c('p', [_vm._v(" Esta classificação elimina interpretações por nome e permite calcular corretamente vendas com pagamentos mistos. ")])])]), _c('div', {
    staticClass: "payment-grid"
  }, _vm._l(_vm.formasPagamentoComClassificacao, function (forma) {
    return _c('div', {
      key: forma.id_forma_pagamento,
      staticClass: "payment-item"
    }, [_c('span', {
      staticClass: "font-weight-bolder"
    }, [_vm._v(_vm._s(forma.descricao))]), _c('b-form-select', {
      attrs: {
        "disabled": !_vm.isEditable,
        "options": _vm.paymentModeOptions
      },
      model: {
        value: forma.modalidade,
        callback: function callback($$v) {
          _vm.$set(forma, "modalidade", $$v);
        },
        expression: "forma.modalidade"
      }
    })], 1);
  }), 0)]), _c('b-tab', {
    attrs: {
      "title": "Apuração e financeiro"
    }
  }, [_c('div', {
    staticClass: "settlement-period-card"
  }, [_c('div', {
    staticClass: "settlement-period-heading"
  }, [_c('div', {
    staticClass: "config-panel-icon is-coral"
  }, [_c('b-icon', {
    attrs: {
      "icon": "calendar-check"
    }
  })], 1), _c('div', [_c('h6', [_vm._v("Competência da apuração")]), _c('p', [_vm._v(" Selecione o mês. O período é definido automaticamente do primeiro ao último dia. ")])]), _c('span', {
    staticClass: "dashboard-chip ml-auto"
  }, [_vm._v(" " + _vm._s(_vm.eventoCompetenciaLabel) + " ")])]), _c('b-row', {
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Mês de referência"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "month"
    },
    on: {
      "change": _vm.aplicarCompetenciaSelecionada
    },
    model: {
      value: _vm.competenciaApuracao,
      callback: function callback($$v) {
        _vm.competenciaApuracao = $$v;
      },
      expression: "competenciaApuracao"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mt-3 mt-md-0",
    attrs: {
      "md": "8"
    }
  }, [_c('span', {
    staticClass: "d-block text-muted font-size-sm mb-2"
  }, [_vm._v(" Período mensal fechado ")]), _c('strong', [_vm._v(" " + _vm._s(_vm.dateBr(_vm.periodo.data_inicial)) + " a " + _vm._s(_vm.dateBr(_vm.periodo.data_final)) + " ")]), _c('small', {
    staticClass: "d-block text-muted mt-1"
  }, [_vm._v(" A data não pode ser personalizada para evitar sobreposição ou lacunas entre competências. ")])])], 1), _c('div', {
    staticClass: "settlement-period-actions"
  }, [_c('button', {
    staticClass: "btn btn-light-primary font-weight-bold mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.simular
    }
  }, [_vm._v(" Atualizar simulação ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.processing || !_vm.podeFecharApuracao,
      "title": _vm.podeFecharApuracao ? '' : 'Salve a configuração antes de fechar competências'
    },
    on: {
      "click": _vm.calcularApuracao
    }
  }, [_vm._v(" " + _vm._s(_vm.podeFecharApuracao ? "Fechar apuração" : "Salve a configuração para fechar") + " ")])]), !_vm.podeFecharApuracao ? _c('div', {
    staticClass: "settlement-draft-note"
  }, [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "info-circle"
    }
  }), _vm._v(" A simulação já pode ser conferida. Salve a configuração antes de gerar o fechamento financeiro. ")], 1) : _vm._e()], 1), _vm.resultado ? _c('div', {
    staticClass: "result-panel"
  }, [_c('div', {
    staticClass: "metrics-grid"
  }, [_c('div', {
    staticClass: "metric-card"
  }, [_c('span', [_vm._v("Base comissionável")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.resultado.equipe.realizado)))])]), _c('div', {
    staticClass: "metric-card"
  }, [_c('span', [_vm._v("Atingimento")]), _c('strong', [_vm._v(_vm._s(_vm.percent(_vm.resultado.equipe.atingimento)))])]), _c('div', {
    staticClass: "metric-card"
  }, [_c('span', [_vm._v("Comissão gerada")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.resultado.equipe.total_pagar)))])]), _c('div', {
    staticClass: "metric-card"
  }, [_c('span', [_vm._v("Aguardando recebimento")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.resultado.equipe.resumo_financeiro.valor_aguardando_recebimento)))])]), _c('div', {
    staticClass: "metric-card featured"
  }, [_c('span', [_vm._v("Comissão a pagar neste mês")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.resultadoPorRecebimento ? _vm.resultado.equipe.resumo_financeiro.valor_disponivel : _vm.resultado.equipe.total_pagar)))])])]), _c('div', {
    staticClass: "table-responsive mt-5"
  }, [_c('table', {
    staticClass: "table table-head-custom table-vertical-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Vendedor")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Realizado")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Meta")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Atingimento")]), _c('th', [_vm._v("Regra / faixa")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Gerada")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Bônus")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Aguardando")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("A pagar")])])]), _c('tbody', _vm._l(_vm.resultado.vendedores, function (vendedor) {
    return _c('tr', {
      key: vendedor.id_vendedor
    }, [_c('td', {
      staticClass: "font-weight-bolder"
    }, [_vm._v(_vm._s(vendedor.nome))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.money(vendedor.realizado_individual)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.moneyNullable(vendedor.meta_individual)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.percent(vendedor.atingimento_individual)) + " ")]), _c('td', [_c('strong', {
      staticClass: "d-block"
    }, [_vm._v(_vm._s(_vm.vendedorRegraLabel(vendedor)))]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.vendedorFaixaLabel(vendedor)))])]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.money(vendedor.total_pagar)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.money(Number(vendedor.bonus_individual || 0) + Number(vendedor.bonus_equipe || 0))) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.vendedorFuture(vendedor).quantidade ? _vm.money(_vm.vendedorFuture(vendedor).comissao_estimada) : "—") + " ")]), _c('td', {
      staticClass: "text-right font-weight-bolder"
    }, [_vm._v(" " + _vm._s(_vm.money(_vm.resultadoPorRecebimento ? _vm.vendedorFinance(vendedor).valor_disponivel : vendedor.total_pagar)) + " ")])]);
  }), 0)])])]) : _vm._e(), _c('div', {
    staticClass: "section-heading mt-10"
  }, [_c('div', [_c('h5', [_vm._v("Competências fechadas")]), _c('p', [_vm._v("Histórico auditável das apurações da empresa.")])])]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-head-custom table-vertical-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Período")]), _c('th', [_vm._v("Configuração usada")]), _c('th', [_vm._v("Status")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Realizado")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Comissão gerada")]), _c('th')])]), _c('tbody', [!_vm.apuracoes.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-8",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(" Nenhuma competência fechada. ")])]) : _vm._e(), _vm._l(_vm.apuracoes, function (apuracao) {
    return _c('tr', {
      key: apuracao.id
    }, [_c('td', [_vm._v(" " + _vm._s(_vm.dateBr(apuracao.data_inicial)) + " a " + _vm._s(_vm.dateBr(apuracao.data_final)) + " ")]), _c('td', [_vm._v(" " + _vm._s(apuracao.plano ? "Configuração de comissões" : "Regras anteriores") + " ")]), _c('td', [_c('span', {
      staticClass: "label label-inline",
      class: _vm.statusClass(apuracao.status)
    }, [_vm._v(" " + _vm._s(_vm.statusLabel(apuracao.status)) + " ")])]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.money(apuracao.realizado_equipe)) + " ")]), _c('td', {
      staticClass: "text-right font-weight-bolder"
    }, [_vm._v(" " + _vm._s(_vm.money(apuracao.total_pagar)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-light-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.carregarApuracao(apuracao.id);
        }
      }
    }, [_vm._v(" Detalhes ")])])]);
  })], 2)])]), _vm.apuracaoSelecionada ? _c('div', {
    staticClass: "settlement-detail settlement-detail-v2 mt-8"
  }, [_c('div', {
    staticClass: "settlement-detail-header"
  }, [_c('div', [_c('span', {
    staticClass: "section-eyebrow"
  }, [_vm._v("Memória do fechamento")]), _c('div', {
    staticClass: "d-flex align-items-center flex-wrap"
  }, [_c('h5', {
    staticClass: "mb-0 mr-3"
  }, [_vm._v(" Apuração #" + _vm._s(_vm.apuracaoSelecionada.id) + " ")]), _c('span', {
    staticClass: "label label-inline",
    class: _vm.statusClass(_vm.apuracaoSelecionada.status)
  }, [_vm._v(" " + _vm._s(_vm.statusLabel(_vm.apuracaoSelecionada.status)) + " ")])]), _c('p', [_vm._v(" " + _vm._s(_vm.dateBr(_vm.apuracaoSelecionada.data_inicial)) + " a " + _vm._s(_vm.dateBr(_vm.apuracaoSelecionada.data_final)) + " · " + _vm._s(_vm.apuracaoPorRecebimento ? "Meta pelas vendas · financeiro após recebimento" : "Meta e financeiro no fechamento") + " ")])]), _c('div', {
    staticClass: "settlement-header-actions"
  }, [_vm.podeCancelarApuracao ? _c('button', {
    staticClass: "btn btn-outline-danger font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.cancelarApuracao
    }
  }, [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "x-circle"
    }
  }), _vm._v(" Cancelar apuração ")], 1) : _vm._e(), _vm.apuracaoSelecionada.status === 'calculado' ? _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.aprovarApuracao
    }
  }, [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "check2-circle"
    }
  }), _vm._v(" Aprovar apuração ")], 1) : _vm._e(), ['aprovado', 'financeiro_gerado'].includes(_vm.apuracaoSelecionada.status) && _vm.resumoFinanceiroApuracao.saldo_liberar > 0 ? _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.gerarFinanceiro
    }
  }, [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "wallet2"
    }
  }), _vm._v(" Gerar financeiro de " + _vm._s(_vm.money(_vm.resumoFinanceiroApuracao.saldo_liberar)) + " ")], 1) : _vm._e()])]), _c('div', {
    staticClass: "settlement-overview-grid"
  }, [_c('div', {
    staticClass: "settlement-overview-item"
  }, [_c('span', [_vm._v("Vendido comissionável")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.apuracaoSelecionada.realizado_equipe)))])]), _c('div', {
    staticClass: "settlement-overview-item"
  }, [_c('span', [_vm._v("Comissão gerada pelas vendas do mês")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.resumoFinanceiroApuracao.valor_gerado)))]), _c('small', [_vm._v("Direito definido pela meta e faixa deste mês.")])]), _c('div', {
    staticClass: "settlement-overview-item"
  }, [_c('span', [_vm._v("Comissão a ser paga neste mês")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.resumoFinanceiroApuracao.valor_a_pagar)))]), _c('small', [_vm._v(" Baixas do mês, inclusive de vendas de meses anteriores. ")])]), _c('div', {
    staticClass: "settlement-overview-item is-total"
  }, [_c('span', [_vm._v("Aguardando recebimento")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.resumoFinanceiroApuracao.valor_aguardando_recebimento)))]), _c('small', [_vm._v("Já gerada, mas ainda fora do financeiro.")])])]), _c('div', {
    staticClass: "seller-settlement-list"
  }, _vm._l(_vm.apuracaoSelecionada.vendedores, function (vendedor) {
    return _c('article', {
      key: vendedor.id,
      staticClass: "seller-settlement-card"
    }, [_c('header', {
      staticClass: "seller-settlement-header"
    }, [_c('div', {
      staticClass: "seller-avatar"
    }, [_vm._v(" " + _vm._s(_vm.initials(vendedor.vendedor_nome)) + " ")]), _c('div', [_c('h6', [_vm._v(_vm._s(vendedor.vendedor_nome))]), _c('p', [_vm._v(" " + _vm._s(_vm.vendedorRegraLabel(vendedor)) + " ")])]), _c('div', {
      staticClass: "seller-settlement-tags"
    }, [_c('span', {
      staticClass: "seller-rule-chip"
    }, [_vm._v(" " + _vm._s(_vm.vendedorFaixaLabel(vendedor)) + " ")]), _c('span', {
      staticClass: "label label-inline",
      class: _vm.sellerFinanceStatusClass(vendedor)
    }, [_vm._v(" " + _vm._s(_vm.sellerFinanceStatusLabel(vendedor)) + " ")])])]), _c('div', {
      staticClass: "seller-settlement-grid"
    }, [_c('section', {
      staticClass: "seller-performance-panel"
    }, [_c('span', {
      staticClass: "seller-panel-label"
    }, [_vm._v("Desempenho")]), _c('div', {
      staticClass: "seller-primary-value"
    }, [_vm._v(" " + _vm._s(_vm.money(vendedor.realizado_individual)) + " ")]), _c('div', {
      staticClass: "seller-goal-row"
    }, [_c('span', [_vm._v(" Meta " + _vm._s(_vm.moneyNullable(vendedor.meta_individual)) + " ")]), _c('strong', [_vm._v(_vm._s(_vm.percent(vendedor.atingimento_individual)))])]), _c('div', {
      staticClass: "seller-progress"
    }, [_c('span', {
      style: {
        width: _vm.progressWidth(vendedor.atingimento_individual)
      }
    })]), _c('div', {
      staticClass: "seller-rule-result"
    }, [_c('span', [_vm._v("Percentual aplicado")]), _c('strong', [_vm._v(_vm._s(_vm.vendedorPercentualLabel(vendedor)))])])]), _c('section', {
      staticClass: "seller-commission-panel"
    }, [_c('span', {
      staticClass: "seller-panel-label"
    }, [_vm._v("Composição da comissão")]), _c('div', {
      staticClass: "commission-breakdown-row"
    }, [_c('span', [_vm._v(" À vista · " + _vm._s(_vm.money(vendedor.total_vista)) + " ")]), _c('strong', [_vm._v(_vm._s(_vm.money(vendedor.comissao_vista)))])]), _c('div', {
      staticClass: "commission-breakdown-row"
    }, [_c('span', [_vm._v(" A prazo · " + _vm._s(_vm.money(vendedor.total_prazo)) + " ")]), _c('strong', [_vm._v(_vm._s(_vm.money(vendedor.comissao_prazo)))])]), _c('div', {
      staticClass: "commission-breakdown-row"
    }, [_c('span', [_vm._v("Bônus")]), _c('strong', [_vm._v(_vm._s(_vm.money(Number(vendedor.bonus_individual || 0) + Number(vendedor.bonus_equipe || 0))))])]), _c('div', {
      staticClass: "commission-breakdown-total"
    }, [_c('span', [_vm._v("Comissão gerada")]), _c('strong', [_vm._v(_vm._s(_vm.money(vendedor.total_pagar)))])])]), _c('aside', {
      staticClass: "seller-finance-panel"
    }, [_c('span', {
      staticClass: "seller-panel-label"
    }, [_vm._v("Pagamento da competência")]), _c('div', {
      staticClass: "finance-status-icon"
    }, [_c('b-icon', {
      attrs: {
        "icon": _vm.vendedorPayment(vendedor).saldo_liberar <= 0 ? 'check-circle' : 'wallet2'
      }
    })], 1), _c('strong', [_vm._v(" " + _vm._s(_vm.money(_vm.vendedorPayment(vendedor).valor_a_pagar)) + " a pagar ")]), _c('p', [_vm._v(" " + _vm._s(_vm.money(_vm.vendedorPayment(vendedor).valor_gerado)) + " gerados pelas vendas · " + _vm._s(_vm.vendedorPayment(vendedor).quantidade) + " item(ns) para pagamento ")]), _vm.vendedorPayment(vendedor).valor_liberado > 0 ? _c('small', {
      staticClass: "d-block text-muted mb-3"
    }, [_vm._v(" " + _vm._s(_vm.money(_vm.vendedorPayment(vendedor).valor_liberado)) + " já gerados no Contas a Pagar ")]) : _vm._e(), (vendedor.liberacoes || []).length ? _c('small', {
      staticClass: "d-block text-muted mb-3"
    }, [_vm._v(" Contas: " + _vm._s(_vm.sellerAccountLabels(vendedor)) + " ")]) : _vm._e(), _c('button', {
      staticClass: "btn btn-sm btn-light-primary btn-block",
      attrs: {
        "type": "button",
        "disabled": _vm.pdfSellerId === vendedor.id_vendedor
      },
      on: {
        "click": function click($event) {
          return _vm.abrirPdfVendedor(vendedor);
        }
      }
    }, [_vm.pdfSellerId === vendedor.id_vendedor ? _c('b-spinner', {
      staticClass: "mr-2",
      attrs: {
        "small": ""
      }
    }) : _c('b-icon', {
      staticClass: "mr-2",
      attrs: {
        "icon": "file-earmark-pdf"
      }
    }), _vm._v(" Abrir PDF ")], 1), _c('button', {
      staticClass: "btn btn-sm btn-link btn-block",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.toggleSellerDetails(vendedor.id);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.sellerDetailsVisible(vendedor.id) ? "Ocultar lançamentos" : "Ver vendas e cálculo") + " "), _c('b-icon', {
      staticClass: "ml-1",
      attrs: {
        "icon": _vm.sellerDetailsVisible(vendedor.id) ? 'chevron-up' : 'chevron-down'
      }
    })], 1)])]), _vm.apuracaoPorRecebimento && _vm.vendedorFuture(vendedor).quantidade > 0 ? _c('div', {
      staticClass: "seller-future-strip"
    }, [_c('b-icon', {
      attrs: {
        "icon": "hourglass-split"
      }
    }), _c('div', [_c('strong', [_vm._v(" " + _vm._s(_vm.vendedorFuture(vendedor).quantidade) + " título(s) aguardando recebimento ")]), _c('span', [_vm._v(" Base futura de " + _vm._s(_vm.money(_vm.vendedorFuture(vendedor).valor_base)) + ". " + _vm._s(_vm.vendedorFuture(vendedor).estimativa_disponivel ? "Estimativa de " + _vm.money(_vm.vendedorFuture(vendedor).comissao_estimada) + "." : "Comissão já definida pela faixa do mês.") + " ")])])], 1) : _vm._e(), _vm.sellerDetailsVisible(vendedor.id) ? _c('div', {
      staticClass: "seller-ledger"
    }, [_c('div', {
      staticClass: "payment-ledger"
    }, [_c('div', {
      staticClass: "seller-ledger-heading"
    }, [_c('div', [_c('strong', [_vm._v("Comissão a ser paga neste mês")]), _c('span', [_vm._v(" Usa a data da baixa. A meta e a taxa continuam sendo as da competência original da venda. ")])]), _c('span', {
      staticClass: "payment-ledger-total"
    }, [_vm._v(" " + _vm._s(_vm.money(_vm.vendedorPayment(vendedor).valor_a_pagar)) + " ")])]), _c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table table-head-custom table-vertical-center mb-0"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Data do evento")]), _c('th', [_vm._v("Documento / cliente")]), _c('th', [_vm._v("Origem da venda")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("Base recebida")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("Taxa original")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("A pagar")]), _c('th', [_vm._v("Status")])])]), _c('tbody', [!_vm.vendedorPayment(vendedor).itens.length ? _c('tr', [_c('td', {
      staticClass: "text-center text-muted py-6",
      attrs: {
        "colspan": "7"
      }
    }, [_vm._v(" Nenhuma comissão foi liberada para pagamento nesta competência. ")])]) : _vm._e(), _vm._l(_vm.vendedorPayment(vendedor).itens, function (item) {
      return _c('tr', {
        key: item.origem_chave
      }, [_c('td', [_vm._v(_vm._s(_vm.dateBr(item.data_evento)))]), _c('td', [_c('strong', [_vm._v(_vm._s(item.documento || "—"))]), _c('small', {
        staticClass: "d-block text-muted"
      }, [_vm._v(" " + _vm._s(item.cliente || "Sem cliente") + " ")])]), _c('td', [_c('strong', [_vm._v(" " + _vm._s(_vm.origemLabel(item.origem_tipo)) + " ")]), _c('small', {
        staticClass: "d-block text-muted"
      }, [_vm._v(" Venda de " + _vm._s(_vm.monthYear(item.competencia_origem)) + " ")])]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(" " + _vm._s(_vm.money(item.valor_base)) + " ")]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(" " + _vm._s(_vm.percent(item.percentual_aplicado)) + " ")]), _c('td', {
        staticClass: "text-right font-weight-bolder"
      }, [_vm._v(" " + _vm._s(_vm.money(item.valor_comissao)) + " ")]), _c('td', [_c('span', {
        staticClass: "label label-inline",
        class: item.id_liberacao ? 'label-light-success' : 'label-light-primary'
      }, [_vm._v(" " + _vm._s(item.id_liberacao ? "Financeiro gerado" : "A gerar") + " ")])])]);
    })], 2)])])]), _vm.apuracaoPorRecebimento ? [_c('div', {
      staticClass: "seller-ledger-heading"
    }, [_c('div', [_c('strong', [_vm._v("Vendas que definiram meta e comissão")]), _c('span', [_vm._v(" Cada linha mostra a base, o percentual e o valor calculado. ")])])]), _c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table table-head-custom table-vertical-center mb-0"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Data")]), _c('th', [_vm._v("Documento / cliente")]), _c('th', [_vm._v("Origem")]), _c('th', [_vm._v("Modalidade")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("Base")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("%")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("Comissão")])])]), _c('tbody', [!vendedor.lancamentos.length ? _c('tr', [_c('td', {
      staticClass: "text-center text-muted py-6",
      attrs: {
        "colspan": "7"
      }
    }, [_vm._v(" Nenhum lançamento comissionável nesta competência. ")])]) : _vm._e(), _vm._l(vendedor.lancamentos, function (lancamento) {
      return _c('tr', {
        key: lancamento.id
      }, [_c('td', [_vm._v(" " + _vm._s(_vm.dateBr(lancamento.data_competencia)) + " ")]), _c('td', [_c('strong', [_vm._v(_vm._s(lancamento.documento || lancamento.descricao || "—"))]), _c('small', {
        staticClass: "d-block text-muted"
      }, [_vm._v(" " + _vm._s(lancamento.cliente || "Sem cliente") + " ")])]), _c('td', [_vm._v(" " + _vm._s(_vm.origemLabel(lancamento.origem_tipo)) + " ")]), _c('td', [_vm._v(" " + _vm._s(_vm.modalidadeLabel(lancamento.modalidade)) + " ")]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(" " + _vm._s(_vm.money(lancamento.valor_base)) + " ")]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(" " + _vm._s(_vm.percent(lancamento.percentual_aplicado)) + " ")]), _c('td', {
        staticClass: "text-right font-weight-bolder"
      }, [_vm._v(" " + _vm._s(_vm.money(lancamento.valor_calculado)) + " ")])]);
    })], 2)])])] : _vm._e(), _vm.apuracaoPorRecebimento && _vm.vendedorFuture(vendedor).quantidade > 0 ? _c('div', {
      staticClass: "future-ledger"
    }, [_c('div', {
      staticClass: "seller-ledger-heading"
    }, [_c('div', [_c('strong', [_vm._v("Vendas ainda não recebidas")]), _c('span', [_vm._v(" Estas vendas já compõem a meta e a faixa; somente a liberação financeira aguarda o recebimento. ")])])]), _c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table table-head-custom table-vertical-center mb-0"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Venda")]), _c('th', [_vm._v("Documento / cliente")]), _c('th', [_vm._v("Vencimento")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("Base futura")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("Comissão")])])]), _c('tbody', _vm._l(_vm.vendedorFuture(vendedor).itens, function (item) {
      return _c('tr', {
        key: item.chave
      }, [_c('td', [_vm._v(_vm._s(_vm.dateBr(item.data_venda)))]), _c('td', [_c('strong', [_vm._v(_vm._s(item.documento))]), _c('small', {
        staticClass: "d-block text-muted"
      }, [_vm._v(" " + _vm._s(item.cliente || "Sem cliente") + " ")])]), _c('td', [_vm._v(_vm._s(_vm.dateBr(item.data_vencimento)))]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(" " + _vm._s(_vm.money(item.valor_base)) + " ")]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(" " + _vm._s(item.comissao_estimada === null ? "A definir" : _vm.money(item.comissao_estimada)) + " ")])]);
    }), 0)])])]) : _vm._e()], 2) : _vm._e()]);
  }), 0)]) : _vm._e()])], 1)], 1), _vm.tabIndex > 0 && _vm.tabIndex < 5 ? _c('div', {
    staticClass: "card-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.salvarPlano
    }
  }, [_vm.saving ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Salvar configurações ")], 1)]) : _vm._e()]], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };